module.exports = __webpack_public_path__ + "static/media/filter.c25a009a.svg";